import { WorkOrderList } from 'Components/Ags/WorkOrder/WorkOrderGrid/WorkOrderList';
import { actions } from 'Data/ReduxViewModels/Ags/WorkOrderGrid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Page from 'Components/Pages/Core/Page';
import './WorkOrderGridPage.scss';

const WorkOrderGridPage: React.FC = () => {
  const userId = useSelector((state) => state.user.data?.UUID);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.init({ userId }));
  }, [dispatch, userId]);

  return (
    <Page heading="Work Orders (last 20 entries)">
      <div className="WorkOrderGridPage">
        <WorkOrderList />
      </div>
    </Page>
  );
};

export default WorkOrderGridPage;
